import { render, staticRenderFns } from "./table_kategorie.vue?vue&type=template&id=99cf6cee&scoped=true"
import script from "./table_kategorie.vue?vue&type=script&lang=js"
export * from "./table_kategorie.vue?vue&type=script&lang=js"
import style0 from "./table_kategorie.vue?vue&type=style&index=0&id=99cf6cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cf6cee",
  null
  
)

export default component.exports